import styles from './index.module.scss';

export default function PartyPlayerSettings() {
  return (
    <div className={styles.LibraryPage}>
      <h2>Party Settings</h2>
    </div>
  );
}
